import React from 'react'
import { Position } from '@blueprintjs/core'
import { Popover2, Popover2Props } from '@blueprintjs/popover2'

interface PopoverProps {
  children?: React.ReactNode
}

export default function ({ children, hasBackdrop, ...props }: PopoverProps & Popover2Props) {
  let extraProps = {}
  if (hasBackdrop) {
    extraProps = {
      hasBackdrop: true,
      backdropProps: { style: { background: 'transparent' } },
      autoFocus: false,
      canEscapeKeyClose: false,
    }
  }
  return (
    <Popover2 minimal position={Position.BOTTOM} {...extraProps} {...props}>
      {children}
    </Popover2>
  )
}
